import React from 'react';
import { FiAlertCircle, FiCheck } from 'react-icons/fi';

const ConfirmationDialog = ({
	open,
	onClose,
	onConfirm,
	message,
	confirmText = 'Confirm',
	cancelText = 'Cancel',
	showIcon = true,
	children
}) => {
	if (!open) return null;

	const handleConfirm = () => {
		if (onConfirm) {
			onConfirm();
		}
		onClose();
	};

	return (
		<>
			{/* Backdrop */}
			<div
				className='fixed inset-0 bg-black bg-opacity-50 z-50 flex items-center justify-center p-4'
				onClick={onClose}
			>
				{/* Dialog */}
				<div
					className='bg-white rounded-lg shadow-xl max-w-md w-full p-6'
					onClick={(e) => e.stopPropagation()}
				>
					{/* Icon */}
					{showIcon && (
						<div className='flex justify-center mb-4'>
							<div className='w-12 h-12 bg-blue-50 rounded-full flex items-center justify-center'>
								<FiAlertCircle className='h-6 w-6 text-blue-600' />
							</div>
						</div>
					)}

					{/* Message */}
					<div className='text-center mb-6'>
						<p className='text-gray-700 font-montserrat-regular'>
							{message}
						</p>
						{children}
					</div>

					{/* Actions */}
					<div className='flex space-x-3'>
						<button
							onClick={onClose}
							className='flex-1 px-4 py-2 bg-gray-100 text-gray-700 rounded-md hover:bg-gray-200 transition-colors font-montserrat-medium text-sm'
						>
							{cancelText}
						</button>
						{onConfirm && (
							<button
								onClick={handleConfirm}
								className='flex-1 px-4 py-2 bg-[#CC1DB9] text-white rounded-md hover:bg-pink-600 transition-colors font-montserrat-medium text-sm'
							>
								{confirmText}
							</button>
						)}
					</div>
				</div>
			</div>
		</>
	);
};

export default ConfirmationDialog;
